<template>
  <iframe
    title="privacy_policy.pdf"
    id="pdf-iframe"
    :src="pdfLink"
    allow="fullscreen"
    frameborder="0"
    marginheight="0"
    marginwidth="0"
    width="100%"
    height="100%"
    scrolling="auto"
  />
</template>

<script>
export default {
    data () {
      return {
        pdfLink : this.$domain == this.$hwUrl ? process.env.HW_PRIVACY_POLICY_URL : process.env.PRIVACY_POLICY_URL
      }
}
}
</script>


// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue